/* custom.js */

document.addEventListener("DOMContentLoaded", function () {
  // ===========================================================//
  // ======== Menu Drawer =========//
  // ===========================================================//

  var announcement_close = document.querySelector(".announcement_close");
  if (announcement_close) {
    announcement_close.addEventListener("click", function () {
      Submenuopen();
      var utility_bar = document.querySelector(".utility-bar");
      if (utility_bar) utility_bar.style.display = "none";
    });
  }

  window.addEventListener("load", function () {
    Submenuopen();
  });

  function Submenuopen() {
    var headerWrapper = document.querySelector(".header-wrapper");
    if (!headerWrapper) return;

    var headerHeight = headerWrapper.offsetHeight;

    var submenuElements = document.querySelectorAll(".header__submenu");
    if (!submenuElements.length) return;

    submenuElements.forEach(function (el) {
      el.style.top = headerHeight + "px";
      el.style.height = "calc(100vh - " + headerHeight + "px)";
    });
  }

  var announcement = $(".utility-bar").outerHeight();
  var header_main = $(".header-wrapper").outerHeight();
  var drawer_height = announcement + header_main;

  if ($(window).width() < 600) {
    $(".js .menu-drawer").css("height", "calc(100svh - " + drawer_height + "px)");
  } else {
    $(".js .menu-drawer").css("height", "calc(100svh - 133px)");
  }

  // ===========================================================//
  // ======== Desktop Mega Menu (smooth, no flicker) ========//
  // ===========================================================//

  (function initMegaMenuHover() {
    var desktopMQ = window.matchMedia("(min-width: 990px)");
    if (!desktopMQ.matches) return;

    var megaItems = Array.prototype.slice.call(
      document.querySelectorAll(".header__inline-menu details.mega-menu")
    );
    if (!megaItems.length) return;

    var active = null;
    var closeTimer = null;

    setMegaMenuTop();
    requestAnimationFrame(function () {
      document.documentElement.classList.add("mm-ready");
    });

    function setMegaMenuTop() {
      var inlineMenu = document.querySelector(".header__inline-menu");
      if (!inlineMenu) return;

      var rect = inlineMenu.getBoundingClientRect();
      document.documentElement.style.setProperty("--mega-menu-top", rect.bottom + "px");
    }

    function forceReflow(el) {
      if (!el) return;
      void el.offsetHeight;
    }

    function closeAllExcept(except) {
      megaItems.forEach(function (m) {
        if (except && m === except) return;
        m.classList.remove("mm-open");
        m.removeAttribute("open");
      });

      if (!except) {
        document.body.classList.remove("mega-menu-open");
        active = null;
        return;
      }

      document.body.classList.add("mega-menu-open");
      active = except;
    }

    function openMenu(m) {
      if (!m) return;

      setMegaMenuTop();
      Submenuopen();

      var content = m.querySelector(".mega-menu__content");
      if (!content) return;

      closeAllExcept(m);

      m.setAttribute("open", "");
      m.classList.remove("mm-open");
      forceReflow(content);

      m.classList.add("mm-open");
      document.body.classList.add("mega-menu-open");
      active = m;
    }

    function scheduleClose() {
      if (closeTimer) clearTimeout(closeTimer);

      closeTimer = setTimeout(function () {
        var anyHover = megaItems.some(function (x) {
          var panel = x.querySelector(".mega-menu__content");
          return x.matches(":hover") || (panel && panel.matches(":hover"));
        });
        if (anyHover) return;

        closeAllExcept(null);
      }, 140);
    }

    window.addEventListener("load", setMegaMenuTop);
    window.addEventListener("resize", setMegaMenuTop);
    window.addEventListener("scroll", setMegaMenuTop, { passive: true });

    megaItems.forEach(function (m) {
      var summary = m.querySelector("summary");
      var content = m.querySelector(".mega-menu__content");
      if (!summary || !content) return;

      summary.addEventListener("click", function (e) {
        e.preventDefault();
      });

      m.addEventListener("mouseenter", function () {
        if (closeTimer) clearTimeout(closeTimer);
        openMenu(m);
      });

      m.addEventListener("mouseleave", function () {
        scheduleClose(m);
      });

      content.addEventListener("mouseenter", function () {
        if (closeTimer) clearTimeout(closeTimer);
        openMenu(m);
      });

      content.addEventListener("mouseleave", function () {
        scheduleClose(m);
      });

      summary.addEventListener("focus", function () {
        if (closeTimer) clearTimeout(closeTimer);
        openMenu(m);
      });

      content.addEventListener("focusin", function () {
        if (closeTimer) clearTimeout(closeTimer);
        openMenu(m);
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAllExcept(null);
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest(".header__inline-menu")) closeAllExcept(null);
    });
  })();
});

$(document).ready(function () {
  // ===========================================================//
  // ======== View click grid set Desktop =========//
  // ===========================================================//

  $(document).on("click", ".view_item", function () {
    var siblings = $(this).parent().children();
    siblings.not(this).removeClass("active");
    $(this).addClass("active");

    var viewItemText = $(this).text().trim();
    localStorage.setItem("select_col", viewItemText);
    desktop(viewItemText);
    tablet_down(viewItemText);
  });

  function desktop(viewItemText) {
    $("#product-grid")
      .removeClass(function (index, className) {
        return (className.match(/(^|\s)grid--\S*-col-desktop/g) || []).join(" ");
      })
      .addClass("grid--" + viewItemText.toLowerCase() + "-col-desktop");
  }

  function tablet_down(viewItemText) {
    $("#product-grid")
      .removeClass(function (index, className) {
        return (className.match(/(^|\s)grid--\S*-col-tablet-down/g) || []).join(" ");
      })
      .addClass("grid--" + viewItemText.toLowerCase() + "-col-tablet-down");
  }

  // restore saved view mode (do NOT use window.onload, it gets overwritten elsewhere)
  (function restoreGridChoice() {
    var viewItemText = localStorage.getItem("select_col");
    if (!viewItemText) return;

    $(".view_item").each(function () {
      var itemText = $(this).text().trim();
      if (itemText === viewItemText) {
        var siblings = $(this).parent().children();
        siblings.not(this).removeClass("active");
        $(this).addClass("active");
      }
    });

    desktop(viewItemText);
    tablet_down(viewItemText);
  })();

  var windowWidth = $(window).width();
  if (windowWidth <= 749) {
    $(".view_item:nth-child(1)").addClass("active");
  } else {
    $(".view_item:nth-child(1)").removeClass("active");
  }

  // ===========================================================//
  // ======== cart drawer =========//
  // ===========================================================//

  try {
    var announcementHeight = document.querySelector(".utility-bar")
      ? document.querySelector(".utility-bar").offsetHeight
      : 0;
    var headerHalf = document.querySelector(".header-wrapper")
      ? document.querySelector(".header-wrapper").offsetHeight / 2
      : 0;

    var total_height = announcementHeight + headerHalf;
    var drawer = document.querySelector(".drawer");
    if (drawer) drawer.style.top = total_height + "px";

    window.addEventListener("scroll", function () {
      var scrollPosition = window.scrollY;

      var drawerEl = document.querySelector(".drawer");
      if (!drawerEl) return;

      if (scrollPosition >= 150) {
        var headerHalf2 = document.querySelector(".header-wrapper")
          ? document.querySelector(".header-wrapper").offsetHeight / 2
          : 0;
        drawerEl.style.top = headerHalf2 + "px";
      } else {
        var announcementHeight2 = document.querySelector(".utility-bar")
          ? document.querySelector(".utility-bar").offsetHeight
          : 0;
        var headerHalf3 = document.querySelector(".header-wrapper")
          ? document.querySelector(".header-wrapper").offsetHeight / 2
          : 0;
        drawerEl.style.top = announcementHeight2 + headerHalf3 + "px";
      }
    });
  } catch (e) {
    // ignore
  }

  // ===========================================================//
  // ======== header scroll css =========//
  // ===========================================================//

  try {
    var announcement_scroll = document.querySelector(".utility-bar")
      ? document.querySelector(".utility-bar").offsetHeight
      : 0;
    var header_main_scroll = document.querySelector(".header-wrapper")
      ? document.querySelector(".header-wrapper").offsetHeight
      : 0;

    var header = $(".scrollheader");
    var pageheight = $(window).height() + 100;

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if ($(window).height() > pageheight) {
        if (scroll >= announcement_scroll) {
          header.removeClass("scrollheader").addClass("coverheader");
          $("#MainContent").css({ "padding-top": header_main_scroll + "px" });
        } else {
          header.removeClass("coverheader").addClass("scrollheader");
          $("#MainContent").css({ "padding-top": "0px" });
        }
      }
    });
  } catch (e) {
    // ignore
  }

  // ===========================================================//
  // ======== Variant image change on click =========//
  // ===========================================================//

  $(document).on("click", ".facets .facets__heading", function () {
    $(this).parents(".open_filters_item").toggleClass("open_filter");
  });

  $(document).on("click", ".facets .facet-filters__label", function () {
    $(this).parents(".open_filters_item").toggleClass("short_by");
  });

  // ===========================================================//
  // ======== Header submenu click event =========//
  // ===========================================================//

  $(document).on("click", ".header__submenu .header__menu-item, .cs-menu__link", function () {
    $(this).parents(".header__submenu li").siblings(".sub_tile_show").removeClass("sub_tile_show");

    if ($(this).parents(".header__submenu li").hasClass("sub_tile_show")) {
      $(this).parents(".header__submenu li").removeClass("sub_tile_show");
    } else {
      $(this).parents(".header__submenu li").addClass("sub_tile_show");
    }
  });

  $(document).on("click", ".main_drawer_item .first_item_event", function () {
    $(this).parents(".main_drawer_item").siblings(".menu_show").removeClass("menu_show");

    if ($(this).parents(".first_item_menu").hasClass("menu_show")) {
      $(this).parents(".first_item_menu").removeClass("menu_show");
    } else {
      $(this).parents(".first_item_menu").addClass("menu_show");
    }
  });

  $(document).on("click", ".second_item_sub", function () {
    $(this).parents(".menu-drawer__inner-submenu li").siblings(".menu_sub_item").removeClass("menu_sub_item");

    if ($(this).parents(".menu-drawer__inner-submenu li").hasClass("menu_sub_item")) {
      $(this).parents(".menu-drawer__inner-submenu li").removeClass("menu_sub_item");
    } else {
      $(this).parents(".menu-drawer__inner-submenu li").addClass("menu_sub_item");
    }
  });

  // ===========================================================//
  // ======== Product Page =========//
  // ===========================================================//

  $(".icon-hamburger").on("click", function () {
    $(this).parents(".header").addClass("menu-opening");
    $(this).parents("body").addClass("open");
  });

  $(".icon-close").on("click", function () {
    $(this).parents(".header").removeClass("menu-opening");
    $(this).parents("body").removeClass("open");
  });

  $(".size_option span").on("click", function () {
    $(this).parents("").addClass("open_size");
  });

  $(".size_heading svg").on("click", function () {
    $("body").css("overflow", "unset");
    $(".product,.product__info-wrapper").removeClass("open_size");
    $(this).parents("").removeClass("open_size");
  });

  // ===========================================================//
  // ======== accordion_list =========//
  // ===========================================================//

  $(document).on("click", ".accordion_list span", function () {
    var $this = $(this);
    $this.parent().siblings().removeClass("active");

    if ($this.next().hasClass("show")) {
      $this.next().removeClass("show");
      $this.parents().removeClass("active");
      $this.next().slideUp(500);
    } else {
      $this.parent().parent().find(".accordion_list .inner_content").removeClass("show");
      $this.parent().parent().find(".accordion_list .inner_content").slideUp(350);
      $this.next().toggleClass("show");
      $this.parent().toggleClass("active");
      $this.next().slideToggle(500);
    }

    var clickedSpanText = $(this).text();
    if (clickedSpanText === "Payment options") {
      if ($(this).parents().hasClass("active")) {
        $(this).parents(".product__info-wrapper").find("square-placement").show();
        $(".inner_content.show").css("margin-top", "0");
      } else {
        $(this).parents(".product__info-wrapper").find("square-placement").hide();
      }
    } else {
      $(this).parents(".product__info-wrapper").find("square-placement").hide();
    }
  });

  $(".main_email_inner svg.close_icon").on("click", function () {
    $(this).parents(".main_email_popup").hide();
    $(this).parents(".main_email_popup").removeClass("active");
  });

  // ===========================================================//
  // ======== Search open/close =========//
  // ===========================================================//

  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".block-991 .header__search").length &&
      !$(event.target).hasClass("onsearch-click")
    ) {
      $(".block-991 .header__search").removeClass("active");
    }
  });

  $(".onsearch-click").on("click", function (e) {
    e.stopPropagation();
    $(".block-991 .header__search").toggleClass("active");
  });

  $(".header__icon--search").on("click", function () {
    $(this).parents(".header__search").addClass("active");
  });

  $(".header__search .search-modal__content .search_icon").on("click", function () {
    $(this).parents(".header__search").removeClass("active");
  });

  // ===========================================================//
  // ======== Email popup timed open =========//
  // ===========================================================//

  setTimeout(function () {
    var mainEmailPopup = document.querySelector(".main_email_popup");
    if (mainEmailPopup) {
      mainEmailPopup.style.display = "block";
      mainEmailPopup.classList.add("active");
    }
  }, 5000);

  // ===========================================================//
  // ======== Sub-t video =========//
  // ===========================================================//

  $(document).on("click", ".sub-t-vid", function () {
    $(this).parents(".sub-t-container").addClass("show_content");
  });

  // ===========================================================//
  // ======== Email popup cookie hide =========//
  // ===========================================================//

  setTimeout(function () {
    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
      }
      return "";
    }

    $(".close_icon").click(function () {
      setCookie("hide_popup", true, 5);
      $(".main_email_popup").hide();
      $(".main_email_popup").removeClass("active");
    });

    var value = getCookie("hide_popup");
    if (value === "true") {
      $(".main_email_popup").addClass("hide_mail_box");
    }
  }, 6000);

  // ===========================================================//
  // ======== Scroll styles injection =========//
  // ===========================================================//

  function scrollFunction() {
    var el = document.getElementById("scroll_styles");
    if (!el) return;

    if (document.documentElement.scrollTop >= 45) {
      el.innerHTML =
        "/* ==== when scrolled on desktop ==== */\n" +
        "@media only screen and (min-width: 768px) {\n" +
        "  #header { transition: 0.4s; }\n" +
        "  .header__heading-logo { transition: 0.4s; max-width: 55% !important; }\n" +
        "  .header--middle-center a.header__heading-link { padding: 15px 0 0 !important; transition: 0.4s; }\n" +
        "}\n";
    } else {
      el.innerHTML = "/* no override (allow defaults through again) */";
    }
  }

  window.addEventListener("scroll", scrollFunction);
  window.addEventListener("resize", scrollFunction);
  scrollFunction();

  // ===========================================================//
  // ======== Customer service tab click =========//
  // ===========================================================//

  $(".tag_title").on("click", function () {
    var titleid = $(this).attr("data-id");
    var newUrl = "/pages/customer-service#" + titleid;

    window.location.href = newUrl;

    $(".tag_title").siblings().removeClass("active");
    $(".tag_title[data-id='" + titleid + "']").addClass("active");

    $(".customer_service_content").siblings().removeClass("active");
    $(".customer_service_content[data-id='" + titleid + "']").addClass("active");
  });
});

// ===========================================================//
// ======== Customer service hash on load =========//
// ===========================================================//

$(window).on("load", function () {
  setTimeout(function () {
    $(".customer_service_sec").show();
  }, 100);
});

$(window).on("load", function () {
  var fragment = window.location.hash;
  var fragmentWithoutHash = fragment.substring(1);

  $(".customer_service_sec .tab_list .tag_title").each(function () {
    if ($(this).attr("data-id") === fragmentWithoutHash) {
      $(this).addClass("active");
    }
  });

  $(".customer_service_sec .page_content_item .customer_service_content").each(function () {
    if ($(this).attr("data-id") === fragmentWithoutHash) {
      $(this).addClass("active");
    }
  });
});

/* ========================================================= */
/* Drawer top positioning like mega menu                      */
/* Put this near the top of custom.js inside DOMContentLoaded */
/* ========================================================= */

function setDrawerTopVar() {
  var headerWrapper = document.querySelector(".header-wrapper");
  if (!headerWrapper) return;

  // Bottom of the header in viewport coords
  var rect = headerWrapper.getBoundingClientRect();

  // drawer top should sit directly under the header
  // rect.bottom is viewport-based, so add current scroll to convert to document position,
  // but since we use position:fixed, we want viewport px.
  document.documentElement.style.setProperty("--drawer-top", rect.bottom + "px");
}

// run once + keep in sync (same pattern as your mega menu)
setDrawerTopVar();
window.addEventListener("load", setDrawerTopVar);
window.addEventListener("resize", setDrawerTopVar);
window.addEventListener("scroll", setDrawerTopVar, { passive: true });

// when you open the drawer, force a refresh
$(document).on("click", ".icon-hamburger, .header__icon--menu", function () {
  setDrawerTopVar();
});

/* Mega Menu */

(function () {
  function initMegaHold() {
    const items = document.querySelectorAll('.header__icons ul.list-menu > li');

    items.forEach((li) => {
      const submenu = li.querySelector(':scope > ul.header__submenu_item');
      if (!submenu) return;

      let closeTimer = null;

      const open = () => {
        if (closeTimer) clearTimeout(closeTimer);
        li.classList.add('mega-open');
      };

      const close = () => {
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          // only close if neither li nor submenu is hovered
          if (!li.matches(':hover') && !submenu.matches(':hover')) {
            li.classList.remove('mega-open');
          }
        }, 250);
      };

      // Keep it open while on trigger or submenu
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', close);

      submenu.addEventListener('mouseenter', open);
      submenu.addEventListener('mouseleave', close);

      // If your theme closes on scroll, reopen while submenu is hovered
      window.addEventListener(
        'scroll',
        () => {
          if (submenu.matches(':hover')) open();
        },
        { passive: true }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaHold);
  } else {
    initMegaHold();
  }
})();


/* Mobile Product Video */

(function () {
  function loadDeferred(deferred) {
    if (!deferred) return false;

    if (typeof deferred.loadContent === "function") {
      deferred.loadContent();
    } else {
      const template = deferred.querySelector("template");
      if (template && template.content) {
        const node = template.content.firstElementChild;
        if (node && !deferred.querySelector(node.tagName)) {
          deferred.appendChild(node.cloneNode(true));
        }
      }
    }

    const video = deferred.querySelector("video");
    if (video) {
      video.muted = true;
      video.playsInline = true;
      const p = video.play();
      if (p && typeof p.catch === "function") p.catch(function () {});
      return true;
    }

    return !!deferred.querySelector("iframe");
  }

  function handle(e) {
    const container = e.target.closest(".product-media-container.media-type-video, .product-media-container.media-type-external_video");
    if (!container) return;

    const deferred = container.querySelector("deferred-media");
    if (!deferred) return;

    e.preventDefault();
    e.stopPropagation();

    loadDeferred(deferred);
  }

  document.addEventListener("click", handle, true);
  document.addEventListener("touchend", handle, { capture: true, passive: false });
})();
